import React from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Visualizer from '../components/Visualizer';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';
import { getClickIds, getFunnel, cameFromVariant, getAffiliateParams } from '../utils/tracking';
import { VARIANT_SITE } from '../utils/variant';


	const VisualizerPage = () => {
		// No ViewContent here — that event means "viewed the pricing page" and is
		// fired by /pricing alone, so the funnel step stays a real signal.
		//
		// VisualizerView is the /visualizer landing itself, so the CRO funnel can
		// separate "reached the visualizer" from "actually scanned a handle"
		// (VisualizerSubmit, fired by the component on submit).
		React.useEffect(() => {
			axios.post('https://api.viralgpt.com/pixel', {
				event: 'VisualizerView',
				funnel: getFunnel(),
				...getClickIds(),
				...getAffiliateParams(),
			}, { withCredentials: true }).catch(() => {});
		}, []);

		return (
			<div>
			  {/* Visitors sent here from startviralgpt.com shouldn't be dropped onto
				  the main marketing home page by the logo — keep them on this page. */}
			  <Navbar hidePricing={!cameFromVariant()} logoHref={cameFromVariant() ? VARIANT_SITE : '/'} />

			  <Visualizer />

				<FAQ/>
				<Footer />
			</div>

		)}

export default VisualizerPage;
